var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Aedu.NotificationContainerView = function (superClass) {
  extend(NotificationContainerView, superClass);
  function NotificationContainerView() {
    return NotificationContainerView.__super__.constructor.apply(this, arguments);
  }
  NotificationContainerView.prototype.events = {
    "click .js-main-nav-notifications-link": "toggleNotificationsDropdown",
    "click .js-main-nav-notifications-count": "toggleNotificationsDropdown",
    "click .js-NotificationsDropdown--markAllClicked": "markAllClicked"
  };
  NotificationContainerView.prototype.initialize = function (options) {
    this.showHighlightedNotification = options.showHighlightedNotification;
    this.notificationsDropdownShown = false;
    this.render();
    return this.addSourceToInternalClicks();
  };
  NotificationContainerView.prototype.render = function () {
    this.ui = {
      $notificationsDropdown: this.$(".js-main-nav-notifications-container"),
      $notificationsContent: this.$(".js-main-nav-notifications-content"),
      $notificationsCounter: this.$(".js-main-nav-notifications-count"),
      $notificationsLink: this.$(".js-main-nav-notifications-link"),
      $markAllClicked: this.$(".js-NotificationsDropdown--markAllClicked")
    };
    this.on("closeNotificationDropdown", this.closeDropdown);
    if (Aedu.serviceAvailability.serviceEnabled("notifications_db")) {
      return this.showUnreadNotificationCount();
    }
  };
  NotificationContainerView.prototype.showUnreadNotificationCount = function () {
    return $.get($r.unread_count_api_v0_notification_messages_path({
      subdomain_param: "api"
    })).done(function (_this) {
      return function (data) {
        var count;
        count = data.count;
        _this.ui.$notificationsCounter.text(_this.formatCount(count));
        _this.addNotificationCountToPageTitle(count);
        if (_this.showHighlightedNotification) {
          return _this.ui.$notificationsLink.click();
        }
      };
    }(this));
  };
  NotificationContainerView.prototype.formatCount = function (count) {
    if (count === 0) {
      return "";
    } else if (count > 99) {
      return "99+";
    } else {
      return count.toString();
    }
  };
  NotificationContainerView.prototype.toggleNotificationsDropdown = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.showHighlightedNotification) {
      this.showHighlightedNotification = false;
    } else if (!this.notificationsAlreadyInitialized) {
      this.populateNotificationContent();
      this.notificationsAlreadyInitialized = true;
    }
    this.resetUnreadNotificationCount();
    if (this.notificationsDropdownShown) {
      return this.closeDropdown();
    } else {
      this.trigger("closeNavDropdowns");
      this.ui.$notificationsDropdown.fadeIn(200);
      $("body").on("click.notificationDropdown", function (_this) {
        return function (e) {
          if (!_this.clickIsInsideNotificationsDropdown(e)) {
            return _this.closeDropdown();
          }
        };
      }(this));
      return this.notificationsDropdownShown = true;
    }
  };
  NotificationContainerView.prototype.resetUnreadNotificationCount = function () {
    this.ui.$notificationsCounter.html("");
    return this.removeNotificationsCountFromPageTitle();
  };
  NotificationContainerView.prototype.markAllClicked = function () {
    this.ui.$notificationsDropdown.find(".js-notification-popover").addClass("notification-popover-message-is-read").removeClass("notification-popover-message-is-unread");
    return $.post($r.update_last_clicked_at_api_v0_notification_messages_path({
      subdomain_param: "api"
    }));
  };
  NotificationContainerView.prototype.closeDropdown = function () {
    $("body").off("click.notificationDropdown");
    this.ui.$notificationsDropdown.hide();
    return this.notificationsDropdownShown = false;
  };
  NotificationContainerView.prototype.clickIsInsideNotificationsDropdown = function (e) {
    return $(e.target).closest(".drop_notifications").length > 0;
  };
  NotificationContainerView.prototype.addNotificationCountToPageTitle = function (count) {
    if (count > 0) {
      return document.title = "(" + this.formatCount(count) + ") " + document.title;
    }
  };
  NotificationContainerView.prototype.removeNotificationsCountFromPageTitle = function () {
    return document.title = document.title.replace(/^\(\d+\)\s+/, "");
  };
  NotificationContainerView.prototype.populateNotificationContent = function () {
    var container;
    container = new Aedu.Notifications.Container();
    return this.ui.$notificationsContent.html(container.$el);
  };
  NotificationContainerView.prototype.addSourceToInternalClicks = function () {
    return this.ui.$notificationsContent.on("click", ".js-notification-popover a, .js-notification-popover .js-NotificationDropdown--action-container *", function (e) {
      var $el;
      $el = $(e.currentTarget).closest(".js-notification-popover");
      $el.addClass("notification-popover-message-is-read").removeClass("notification-popover-message-is-unread");
      $.post($r.mark_clicked_api_v0_notification_messages_path({
        ids: JSON.stringify($el.data("notification-message-ids")),
        subdomain_param: "api"
      }));
      return $a.track_single_request_with_source("notification_popover", {
        notification_type: $el.data('notification-message-type')
      });
    });
  };
  return NotificationContainerView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;